import { Portal } from '@ardoq/basic-components';
import { NavigatorContent } from './navigatorContent';
import { DragTarget } from './DragTarget';
import { NavigatorWrapper } from './Atoms';
import { NavigatorContainerProps } from './PropTypes';
import { useEffect, useRef } from 'react';
import { dispatchAction } from '@ardoq/rxbeach';
import {
  containerCreated,
  containerHeightChanged,
} from '../actions/navigatorActions';

const NavigatorContainer = ({
  name,
  isMultiselectable,
  eventListeners: {
    onClick,
    onScroll,
    onMouseDown,
    onContextMenu,
    onMouseOver,
  },
  navigatorContainerClassName,
  renderProps,
  navigatorContentStyle,
  dragElementRoot,
  dragGhostProps,
  parentDropTargetIndicatorStyle,
  isInitialized,
  layoutBoxesContainerStyle,
  actionNamespace,
  backgroundColor,
  components,
  isControlledContainerHeight,
  navigatorContainerId,
  navigatorContentId,
  navigatorContentClassName,
  onRootResize,
}: NavigatorContainerProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (isInitialized && containerRef.current) {
      dispatchAction(
        containerCreated({ container: containerRef.current }),
        actionNamespace
      );
      dispatchAction(containerHeightChanged(), actionNamespace);
    }
  }, [containerRef, isInitialized, actionNamespace]);

  useEffect(() => {
    if (!(containerRef.current && onRootResize)) return;
    const resizeObserver = new ResizeObserver(onRootResize);
    resizeObserver.observe(containerRef.current);
    return () => resizeObserver?.disconnect();
  }, [containerRef, onRootResize]);

  return (
    <>
      <NavigatorWrapper
        id={navigatorContainerId}
        ref={containerRef}
        onClick={onClick}
        onScroll={onScroll}
        onMouseDown={onMouseDown}
        className={navigatorContainerClassName}
        onContextMenu={onContextMenu}
        $backgroundColor={backgroundColor}
        onMouseOver={onMouseOver}
        $isControlledContainerHeight={isControlledContainerHeight}
      >
        <NavigatorContent
          name={name}
          isMultiselectable={isMultiselectable}
          renderProps={renderProps}
          navigatorContentStyle={navigatorContentStyle}
          parentDropTargetIndicatorStyle={parentDropTargetIndicatorStyle}
          layoutBoxesContainerStyle={layoutBoxesContainerStyle}
          components={components}
          navigatorContentId={navigatorContentId}
          navigatorContentClassName={navigatorContentClassName}
        />
      </NavigatorWrapper>
      <Portal to={dragElementRoot}>
        <DragTarget {...dragGhostProps} />
      </Portal>
    </>
  );
};

export { NavigatorContainer };
